import {
  BookWidgetAem,
  BookWidgetFields
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { validateAirports } from './airports-validation.adapter';
import { validateDates } from './dates-validation.adapter';
import { validateMeetingEventCode } from './meeting-event-code-validation.adapter';

export const validateBookWidgetFields = (
  bookWidgetFields: BookWidgetFields,
  startFieldsValidation: boolean,
  bookWidgetAem: BookWidgetAem | null
) => {
  let fieldsErrorCount = 0;
  let updatedBookWidgetFields = { ...bookWidgetFields };

  //meeting event code validation
  ({ fieldsErrorCount, updatedBookWidgetFields } = validateMeetingEventCode(
    updatedBookWidgetFields,
    fieldsErrorCount,
    startFieldsValidation,
    bookWidgetAem
  ));

  //dates validation
  ({ fieldsErrorCount, updatedBookWidgetFields } = validateDates(
    updatedBookWidgetFields,
    fieldsErrorCount,
    startFieldsValidation,
    bookWidgetAem
  ));

  //airports validation
  ({ fieldsErrorCount, updatedBookWidgetFields } = validateAirports(
    updatedBookWidgetFields,
    fieldsErrorCount,
    startFieldsValidation,
    bookWidgetAem
  ));

  return { fieldsErrorCount, updatedBookWidgetFields };
};
